import moment from 'moment-timezone';

import { Event } from '../interfaces';
import { dateFormats } from '../constants/dateTime';
import { getTimeOffset } from './getTimeOffset';

export const getTimeBetweenEvents = (originalEvent: Event, currentEvent: Event, timezone: string): string => {
  if (!originalEvent || !currentEvent) {
    return '';
  }
  const capturedAt = moment.tz(currentEvent.captured_at, timezone).format(dateFormats.timeWithSeconds);

  return `${capturedAt} (${getTimeOffset(originalEvent, currentEvent)})`;
};
